// extracted by mini-css-extract-plugin
module.exports = {"container":"j0","bottomGradient":"j1","image":"j2","brandLogoFrame":"j3","logoImage":"j4","logoImageFrame":"j5"};